export interface CanvasSizePreset {
  id: string;
  label: string;
  width: number;
  height: number;
  dimensions: string;
  shapeClassName: string;
}

export const CANVAS_SIZES: CanvasSizePreset[] = [
  { id: 'square', label: 'Cuadrado', width: 1080, height: 1080, dimensions: '1080 x 1080 px', shapeClassName: 'w-8 h-8' },
  { id: 'vertical', label: 'Vertical', width: 1080, height: 1920, dimensions: '1080 x 1920 px', shapeClassName: 'w-6 h-10' },
  { id: 'horizontal', label: 'Horizontal', width: 1200, height: 628, dimensions: '1200 x 628px', shapeClassName: 'w-10 h-6' },
];

export const CUSTOM_SIZE_ID = 'custom';
export const DEFAULT_CANVAS_SIZE = CANVAS_SIZES[0];
